import Flux from 'lib/flux';

export default Flux.createConstants({
  serviceMessages: ['UPDATE_PARENT_VIEWPORT', 'UPDATE_ORIGIN_URL'],
});
